
/* styles */
require("!!vue-style-loader!css-loader?minimize!../node_modules/vue-loader/lib/style-rewriter?id=data-v-5ec52c63!less-loader!../node_modules/vue-loader/lib/selector?type=styles&index=0!./xlsx-to-table.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./xlsx-to-table.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-5ec52c63!../node_modules/vue-loader/lib/selector?type=template&index=0!./xlsx-to-table.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/xlsx-to-table.vue
// module id = 2
// module chunks = 0